import { Link } from "expo-router";
import { View, Text } from "react-native";
import { surface, text, spacing } from "../src/theme/tokens";

export default function NotFound() {
  return <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: spacing.xl, gap: spacing.lg, backgroundColor: surface.secondary }}>
    <Text accessibilityRole="header" style={{ color: text.primary, fontSize: 24 }}>Page introuvable</Text>
    <Link href="/" style={{ color: text.brand, padding: spacing.lg }}>Revenir à l’accueil</Link>
  </View>;
}
